module.exports = __webpack_public_path__ + "static/j-0e1206eaeb5ba5b0c360d75a7b468f8d.png";